var translationsMap = {
    cs: require('./assets/locale/checkout-components/messages_cs.json'),
    da: require('./assets/locale/checkout-components/messages_da.json'),
    de: require('./assets/locale/checkout-components/messages_de.json'),
    en: require('./assets/locale/checkout-components/messages_en.json'),
    es: require('./assets/locale/checkout-components/messages_es.json'),
    fr: require('./assets/locale/checkout-components/messages_fr.json'),
    hi: require('./assets/locale/checkout-components/messages_hi.json'),
    it: require('./assets/locale/checkout-components/messages_it.json'),
    ja: require('./assets/locale/checkout-components/messages_ja.json'),
    ko: require('./assets/locale/checkout-components/messages_ko.json'),
    nl: require('./assets/locale/checkout-components/messages_nl.json'),
    no: require('./assets/locale/checkout-components/messages_no.json'),
    pl: require('./assets/locale/checkout-components/messages_pl.json'),
    pt: require('./assets/locale/checkout-components/messages_pt.json'),
    ru: require('./assets/locale/checkout-components/messages_ru.json'),
    sv: require('./assets/locale/checkout-components/messages_sv.json'),
    th: require('./assets/locale/checkout-components/messages_th.json'),
    tr: require('./assets/locale/checkout-components/messages_tr.json'),
    uk: require('./assets/locale/checkout-components/messages_uk.json'),
    vi: require('./assets/locale/checkout-components/messages_vi.json'),
    zh: require('./assets/locale/checkout-components/messages_zh.json'),
};
export var getTranslatedErrorMessage = function (locale, flowType) {
    var translations = translationsMap[locale];
    var key = "checkout_page_components.network-error-messages.".concat(flowType);
    return translations ? translations[key] : '';
};
//# sourceMappingURL=error-translations.js.map